import { Guid } from "../../Data/Guid";

export class ExportContextModel {
	public selectedExportRecords: Set<Guid> = new Set<Guid>();
	constructor(mcm?: Partial<ExportContextModel>) {
		Object.assign(this, mcm);
	}
}
